/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React from 'react';
import 'rc-slider/assets/index.css';
import './Replay.scss';
import { BugStore } from 'stores/private/BugStore';
import { inject } from 'mobx-react';
import PrimaryButton from 'components/PrimaryButton/PrimaryButton';
import ReplaysInfo from 'assets/icons/ReplayFrame.png';
import { ProjectStore } from 'stores/private/ProjectStore';
import { useNavigate } from 'react-router';
import { ModalStore } from 'stores/private/ModalStore';
import SuggestSubscription from 'components/SuggestSubscription/SuggestSubscription';
import { Feature } from 'models/Enums';
import classNames from 'classnames';
import AppReplay from './AppReplay';
import WebReplay from './WebReplay';
import suggestSubscriptionIcon from '../../../assets/icons/video-duotone.svg';

interface ReplayProps {
  bugStore?: BugStore;
  projectStore?: ProjectStore;
  modalStore?: ModalStore;
  shared?: boolean;
}

const Replay = ({
  bugStore,
  projectStore,
  modalStore,
  shared = false,
}: ReplayProps) => {
  const navigate = useNavigate();
  const bug = bugStore!.currentBug;
  const planIsEntitled = bugStore?.isFeatureInPlan(Feature.REPLAYS);
  const darkMode = localStorage.getItem('theme') === 'dark';
  const suggestSubscriptionClass = classNames(
    {
      'replay-container--bg--light': !darkMode,
      'replay-container--bg--dark': darkMode,
    },
    'replay-container replay-container--bg',
  );

  if (!planIsEntitled) {
    return (
      <div className={suggestSubscriptionClass}>
        <SuggestSubscription
          icon={suggestSubscriptionIcon}
          title="Replays"
          description="Unlock Gleap Team for $109/month to access a full replay of a user’s steps before a report, allowing you to see exactly what they see."
        />
      </div>
    );
  }

  if (bug && bug.replay && bug.replay.frames.length > 0) {
    return <AppReplay />;
  }

  if (bug && bug.hasWebReplay) {
    return <WebReplay />;
  }

  return (
    <div className="replay-container replay-container--no-contents text">
      <img src={ReplaysInfo} className="no-replays" alt="Gleap Replays" />
      <div>No replay recorded for this ticket.</div>
      {!shared && (
        <div className="mt-20">
          <PrimaryButton
            label="Enable replays"
            onClick={() => {
              modalStore!.closeModal();
              setTimeout(() => {
                navigate(
                  `/projects/${projectStore?.currentProject?.id}/widget/advanced`,
                );
              }, 500);
            }}
          />
        </div>
      )}
    </div>
  );
};

export default inject('bugStore', 'projectStore', 'modalStore')(Replay);
